import { Sort } from '@angular/material/sort';
import { ModuleUser } from '../../module-user/models/module-user.model';

export class SetMyEndedModules {
    static readonly type = '[MyEndedModulesPaginated] SetMyEndedModules';

    constructor(public payload: ModuleUser[]) {}
}

export class UnsetMyEndedModules {
    static readonly type = '[MyEndedModulesPaginated] UnsetMyEndedModules';
}

export class AddMyEndedModules {
    static readonly type = '[MyEndedModulesPaginated] AddMyEndedModules';

    constructor(public payload: ModuleUser[]) {}
}

export class FetchMyEndedModule {
    static readonly type = '[MyEndedModulesPaginated] FetchMyEndedModule';

    constructor(public payload: string) {}
}

export class FetchMyEndedModulesPaginated {
    static readonly type = '[MyEndedModulesPaginated] FetchMyEndedModulesPaginated';

    constructor(
        public payload?: {
            category: string;
            search?: string;
            sortBy?: string;
            sortOrder?: string;
            pageSize?: number;
            pageNumber?: number;
            isEnded?: boolean;
            participantId?: string;
            tag?: number[];
        }
    ) {}
}

export class FetchMyEndedModulesPaginatedSuccess {
    static readonly type = '[MyEndedModulesPaginated] FetchMyEndedModulesPaginatedSuccess';
}

export class FetchMyEndedModulesPaginatedFailure {
    static readonly type = '[MyEndedModulesPaginated] FetchMyEndedModulesPaginatedFailure';
}

export class ToggleSelectedModule {
    static readonly type = '[MyEndedModulesPaginated] ToggleSelectedModule';

    constructor(public payload: string) {}
}

export class SelectFilteredModules {
    static readonly type = '[MyEndedModulesPaginated] SelectFilteredModules';
}

export class DeselectSelectedModules {
    static readonly type = '[MyEndedModulesPaginated] DeselectSelectedModules';
}

export class SearchMyEndedModules {
    static readonly type = '[MyEndedModulesPaginated] SearchMyEndedModules';

    constructor(public payload: string) {}
}

export class SortMyEndedModules {
    static readonly type = '[MyEndedModulesPaginated] SetMyEndedModulesSort';

    constructor(public payload: Sort) {}
}
